import { seedFromWord } from '@support/lib/fake-data';

import { addCustomFields } from './add-custom-fields';

export const initFakeDataFromWord = (seedWord: string) => {
  const faker = seedFromWord(seedWord);
  return addCustomFields(faker);
};
